import Icon, { MessageOutlined } from '@ant-design/icons';

import { fmt } from 'components/IntlWrapper/IntlWrapper';

import { ReactComponent as ShipmentLogo } from 'assets/images/menu-shipments-icon.svg';
import { ReactComponent as ProductsLogo } from 'assets/bosta-icons/Product.svg';
import { ReactComponent as SllrStoreLogo } from 'assets/bosta-icons/Shop.svg';
import { ReactComponent as PalleteLogo } from 'assets/icons/Pallete.svg';
import { ReactComponent as WalletLogo } from 'assets/images/menu-wallet-icon.svg';
import { ReactComponent as SettingsLogo } from 'assets/images/menu-settings-icon.svg';
import { ReactComponent as AnalyticsLogo } from 'assets/images/menu-analytics-icon.svg';
import { ReactComponent as DiscountIcon } from 'assets/bosta-icons/Discount.svg';
import { ReactComponent as AppsAndAddOns } from 'assets/icons/add-ons.svg';
import { ReactComponent as DocumentIcon } from 'assets/bosta-icons/Document.svg';
import { ReactComponent as TeamMembersIcon } from 'assets/bosta-icons/Team Members.svg';

export const MEMBER_PERMISSIONS = {
  ALL_PERMISSIONS: 'allPermissions',
  LIMITED_PERMISSIONS: 'limitedPermissions'
};

export const MEMBER_PERMISSIONS_NAME = {
  [MEMBER_PERMISSIONS.ALL_PERMISSIONS]: fmt({
    id: 'team_members.permissions.all_permissions'
  }),
  [MEMBER_PERMISSIONS.LIMITED_PERMISSIONS]: fmt({
    id: 'team_members.permissions.limited_permissions'
  })
};

export const MEMBER_STATUS_CODES = {
  INVITATION_SENT: 10,
  EMAIL_VERIFIED: 15,
  ACTIVE: 20,
  SUSPENDED: 30
};

export const MEMBER_STATUS_NAME_ID = {
  [MEMBER_STATUS_CODES.INVITATION_SENT]: 'invitation_sent',
  [MEMBER_STATUS_CODES.EMAIL_VERIFIED]: 'invitation_sent',
  [MEMBER_STATUS_CODES.ACTIVE]: 'active',
  [MEMBER_STATUS_CODES.SUSPENDED]: 'suspended'
};

export const PERMISSIONS_OPTIONS_VALUE = {
  FULL_ACCESS: 'fullAccess',
  EDITOR: 'editor',
  VIEW_ONLY: 'viewer',
  NO_ACCESS: 'noAccess'
};

export const PERMISSIONS_MODULES_ID = {
  DELIVERIES: 'deliveries',
  PICKUPS: 'pickups',
  PRODUCTS: 'products',
  PRODUCT_CATEGORY: 'productCategory',
  DISCOUNTS: 'discounts',
  PAGES: 'pages',
  STORE_DESIGN: 'storeDesign',
  APP_STORE: 'appStore',
  ONLINE_STORE: 'onlineStore',
  TEAM_MEMBERS: 'teamMembers',
  ANALYTICS: 'analytics',
  WALLET: 'wallet',
  CHATS: 'chats',
  SETTINGS: 'settings'
};

export const PERMISSIONS_MODULES = [
  {
    apiKey: PERMISSIONS_MODULES_ID.DELIVERIES,
    defaultAccess: PERMISSIONS_OPTIONS_VALUE.EDITOR,
    icon: <Icon component={ShipmentLogo} />,
    title: fmt({
      id: 'team_members.create_edit_member.permissions_section.modules.orders_and_pickups.title'
    }),
    description: {
      [PERMISSIONS_OPTIONS_VALUE.FULL_ACCESS]: fmt(
        {
          id: 'team_members.create_edit_member.permissions_section.modules.orders_and_pickups.description.full_access'
        },
        {
          break: <br />
        }
      ),
      [PERMISSIONS_OPTIONS_VALUE.EDITOR]: fmt(
        {
          id: 'team_members.create_edit_member.permissions_section.modules.orders_and_pickups.description.editor'
        },
        {
          break: <br />
        }
      ),
      [PERMISSIONS_OPTIONS_VALUE.VIEW_ONLY]: fmt({
        id: 'team_members.create_edit_member.permissions_section.modules.orders_and_pickups.description.view_only'
      })
    }
  },
  {
    apiKey: PERMISSIONS_MODULES_ID.PRODUCTS,
    defaultAccess: PERMISSIONS_OPTIONS_VALUE.EDITOR,
    icon: <Icon component={ProductsLogo} />,
    title: fmt({
      id: 'team_members.create_edit_member.permissions_section.modules.products_and_categories.title'
    }),
    description: {
      [PERMISSIONS_OPTIONS_VALUE.FULL_ACCESS]: fmt(
        {
          id: 'team_members.create_edit_member.permissions_section.modules.products_and_categories.description.full_access'
        },
        {
          break: <br />
        }
      ),
      [PERMISSIONS_OPTIONS_VALUE.EDITOR]: fmt(
        {
          id: 'team_members.create_edit_member.permissions_section.modules.products_and_categories.description.editor'
        },
        {
          break: <br />
        }
      ),
      [PERMISSIONS_OPTIONS_VALUE.VIEW_ONLY]: fmt({
        id: 'team_members.create_edit_member.permissions_section.modules.products_and_categories.description.view_only'
      })
    }
  },
  {
    apiKey: PERMISSIONS_MODULES_ID.DISCOUNTS,
    defaultAccess: PERMISSIONS_OPTIONS_VALUE.EDITOR,
    icon: <Icon className="no-icon-fill" component={DiscountIcon} />,
    title: fmt({
      id: 'team_members.create_edit_member.permissions_section.modules.discounts.title'
    }),
    description: {
      [PERMISSIONS_OPTIONS_VALUE.FULL_ACCESS]: fmt({
        id: 'team_members.create_edit_member.permissions_section.modules.discounts.description.full_access'
      }),
      [PERMISSIONS_OPTIONS_VALUE.EDITOR]: fmt({
        id: 'team_members.create_edit_member.permissions_section.modules.discounts.description.editor'
      }),
      [PERMISSIONS_OPTIONS_VALUE.VIEW_ONLY]: fmt({
        id: 'team_members.create_edit_member.permissions_section.modules.discounts.description.view_only'
      })
    }
  },
  {
    apiKey: PERMISSIONS_MODULES_ID.PAGES,
    defaultAccess: PERMISSIONS_OPTIONS_VALUE.EDITOR,
    icon: <Icon component={DocumentIcon} />,
    title: fmt({
      id: 'team_members.create_edit_member.permissions_section.modules.pages.title'
    }),
    description: {
      [PERMISSIONS_OPTIONS_VALUE.FULL_ACCESS]: fmt({
        id: 'team_members.create_edit_member.permissions_section.modules.pages.description.full_access'
      }),
      [PERMISSIONS_OPTIONS_VALUE.EDITOR]: fmt({
        id: 'team_members.create_edit_member.permissions_section.modules.pages.description.editor'
      }),
      [PERMISSIONS_OPTIONS_VALUE.VIEW_ONLY]: fmt({
        id: 'team_members.create_edit_member.permissions_section.modules.pages.description.view_only'
      })
    }
  },
  {
    apiKey: PERMISSIONS_MODULES_ID.STORE_DESIGN,
    defaultAccess: PERMISSIONS_OPTIONS_VALUE.EDITOR,
    icon: <Icon className="no-icon-fill" component={PalleteLogo} />,
    title: fmt({
      id: 'team_members.create_edit_member.permissions_section.modules.store_design.title'
    }),
    description: {
      [PERMISSIONS_OPTIONS_VALUE.FULL_ACCESS]: fmt({
        id: 'team_members.create_edit_member.permissions_section.modules.store_design.description.full_access'
      }),
      [PERMISSIONS_OPTIONS_VALUE.EDITOR]: fmt({
        id: 'team_members.create_edit_member.permissions_section.modules.store_design.description.editor'
      }),
      [PERMISSIONS_OPTIONS_VALUE.VIEW_ONLY]: fmt({
        id: 'team_members.create_edit_member.permissions_section.modules.store_design.description.view_only'
      })
    }
  },
  {
    apiKey: PERMISSIONS_MODULES_ID.APP_STORE,
    defaultAccess: PERMISSIONS_OPTIONS_VALUE.FULL_ACCESS,
    icon: <Icon component={AppsAndAddOns} />,
    title: fmt({
      id: 'team_members.create_edit_member.permissions_section.modules.app_store.title'
    }),
    description: {
      [PERMISSIONS_OPTIONS_VALUE.FULL_ACCESS]: fmt({
        id: 'team_members.create_edit_member.permissions_section.modules.app_store.description.full_access'
      }),
      [PERMISSIONS_OPTIONS_VALUE.VIEW_ONLY]: fmt({
        id: 'team_members.create_edit_member.permissions_section.modules.app_store.description.view_only'
      })
    }
  },
  {
    apiKey: PERMISSIONS_MODULES_ID.ONLINE_STORE,
    defaultAccess: PERMISSIONS_OPTIONS_VALUE.EDITOR,
    icon: <Icon className="no-icon-fill" component={SllrStoreLogo} />,
    title: fmt({
      id: 'team_members.create_edit_member.permissions_section.modules.online_store.title'
    }),
    description: {
      [PERMISSIONS_OPTIONS_VALUE.FULL_ACCESS]: fmt({
        id: 'team_members.create_edit_member.permissions_section.modules.online_store.description.full_access'
      }),
      [PERMISSIONS_OPTIONS_VALUE.EDITOR]: fmt({
        id: 'team_members.create_edit_member.permissions_section.modules.online_store.description.editor'
      }),
      [PERMISSIONS_OPTIONS_VALUE.VIEW_ONLY]: fmt({
        id: 'team_members.create_edit_member.permissions_section.modules.online_store.description.view_only'
      })
    }
  },
  {
    apiKey: PERMISSIONS_MODULES_ID.TEAM_MEMBERS,
    defaultAccess: PERMISSIONS_OPTIONS_VALUE.EDITOR,
    icon: <Icon component={TeamMembersIcon} />,
    title: fmt({
      id: 'team_members.create_edit_member.permissions_section.modules.team_members.title'
    }),
    description: {
      [PERMISSIONS_OPTIONS_VALUE.FULL_ACCESS]: fmt({
        id: 'team_members.create_edit_member.permissions_section.modules.team_members.description.full_access'
      }),
      [PERMISSIONS_OPTIONS_VALUE.EDITOR]: fmt({
        id: 'team_members.create_edit_member.permissions_section.modules.team_members.description.editor'
      }),
      [PERMISSIONS_OPTIONS_VALUE.VIEW_ONLY]: fmt({
        id: 'team_members.create_edit_member.permissions_section.modules.team_members.description.view_only'
      })
    },
    fullAccessTooltip: fmt({
      id: 'team_members.create_edit_member.permissions_section.modules.team_members.tooltip'
    })
  },
  {
    apiKey: PERMISSIONS_MODULES_ID.WALLET,
    defaultAccess: PERMISSIONS_OPTIONS_VALUE.FULL_ACCESS,
    icon: <Icon component={WalletLogo} />,
    title: fmt({
      id: 'team_members.create_edit_member.permissions_section.modules.wallet.title'
    }),
    description: {
      [PERMISSIONS_OPTIONS_VALUE.FULL_ACCESS]: fmt({
        id: 'team_members.create_edit_member.permissions_section.modules.wallet.description.full_access'
      }),
      [PERMISSIONS_OPTIONS_VALUE.VIEW_ONLY]: fmt({
        id: 'team_members.create_edit_member.permissions_section.modules.wallet.description.view_only'
      })
    }
  },
  {
    apiKey: PERMISSIONS_MODULES_ID.CHATS,
    defaultAccess: PERMISSIONS_OPTIONS_VALUE.EDITOR,
    icon: <Icon component={MessageOutlined} />,
    title: fmt({
      id: 'team_members.create_edit_member.permissions_section.modules.chats.title'
    }),
    description: {
      [PERMISSIONS_OPTIONS_VALUE.EDITOR]: fmt({
        id: 'team_members.create_edit_member.permissions_section.modules.chats.description.editor'
      })
    }
  },
  {
    apiKey: PERMISSIONS_MODULES_ID.SETTINGS,
    defaultAccess: PERMISSIONS_OPTIONS_VALUE.VIEW_ONLY,
    icon: <Icon component={SettingsLogo} />,
    title: fmt({
      id: 'team_members.create_edit_member.permissions_section.modules.settings.title'
    }),
    description: {
      [PERMISSIONS_OPTIONS_VALUE.FULL_ACCESS]: fmt({
        id: 'team_members.create_edit_member.permissions_section.modules.settings.description.full_access'
      }),
      [PERMISSIONS_OPTIONS_VALUE.VIEW_ONLY]: fmt({
        id: 'team_members.create_edit_member.permissions_section.modules.settings.description.view_only'
      })
    },
    fullAccessTooltip: fmt({
      id: 'team_members.create_edit_member.permissions_section.modules.settings.tooltip'
    })
  },
  {
    apiKey: PERMISSIONS_MODULES_ID.ANALYTICS,
    defaultAccess: PERMISSIONS_OPTIONS_VALUE.VIEW_ONLY,
    icon: <Icon component={AnalyticsLogo} />,
    title: fmt({
      id: 'team_members.create_edit_member.permissions_section.modules.analytics.title'
    }),
    description: {
      [PERMISSIONS_OPTIONS_VALUE.VIEW_ONLY]: fmt({
        id: 'team_members.create_edit_member.permissions_section.modules.analytics.description.view_only'
      })
    }
  }
];

const DEFAULT_PERMISSION_MODULE = PERMISSIONS_MODULES[0];

export const DEFAULT_PERMISSION_MODULE_ACCESS = {
  [DEFAULT_PERMISSION_MODULE.apiKey]: DEFAULT_PERMISSION_MODULE.defaultAccess
};

export const RESPONSE_ERROR_CODES = {
  REPEATED_EMAIL: [1043, 1044],
  REPEATED_NAME: [1115]
};
